/** @format */

import axios from 'axios';
// import {useHistory} from 'react-router-dom';
import {
	getStoredAuthToken,
	removeStoredAuthToken,
} from '../../utils/authToken';
import { error as errorToast } from '../../Components/Toast';
import { baseApiUrl } from '../../utils/helper';

const defaults = {
	baseURL: baseApiUrl(),
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: getStoredAuthToken()
			? `Bearer ${getStoredAuthToken()}`
			: undefined,
	},
	error: {
		code: 'INTERNAL_ERROR',
		message:
			'Something went wrong. Please check your internet connection or contact our support.',
		status: 503,
		data: {},
	},
};

const api = async (
	method,
	url,
	variables,
	fullfill,
	reject,
	fileUpload = false,
) => {
	let formData = {};
	if (fileUpload) {
		defaults['headers']['Content-Type'] = 'multipart/form-data';
		formData = new FormData();
		if (variables) {
			for (const property in variables) {
				formData.append(property, variables[property]);
			}
		}
	} else {
		defaults['headers']['Content-Type'] = 'application/json';
		formData = JSON.stringify(variables);
	}
	await axios({
		headers: defaults.headers,
		baseURL: defaults.baseURL,
		url: url,
		method,
		params: method !== 'post' && method !== 'put' ? variables : undefined,
		data: method !== 'get' ? formData : undefined,
	}).then(
		(response) => {
			fullfill(response);
		},
		(error) => {
			if (error.response) {
				if (error.response.status === 429) {
					// return (window.location.href = '/429');
				}
				if (error.response.status === 401) {
					//Unauthorized
					resetToken();
					// console.log(error.response);
				} else if (error.response.status === 422) {
					reject(error.response);
				} else if (error.response.status === 405) {
					reject(error.response);
				} else if (error.response.status === 406) {
					reject(error.response);
				} else if (error.response.status === 400) {
					reject(error.response);
				} else {
					reject(error.response.data);
				}
			} else {
				reject(defaults.error);
			}
		},
	);
};

const resetToken = () => {
	removeStoredAuthToken();
	errorToast('مشخصات ورود اشتباه است');
	let getUrl = window.location;
	let baseUrl = getUrl.protocol + '//' + getUrl.host;
	window.location.replace(baseUrl + '/login');
};

const batchGet = async (urls) => {
	let data = [];
	for (let i = 0; i < urls.length; i += 4) {
		//Chunk request to four request
		let chunkUrls = urls.slice(i, i + 4);

		try {
			const res = await Promise.all(
				chunkUrls.map((url) => axios.get(url, { headers: defaults.headers() })),
			);

			data = [...data, ...res.map((res) => res.data)];
		} catch (error) {
			throw Error(error);
		}
	}

	return data;
};

const EXCEL_MIME =
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const getHeaderValue = (headers, name) => {
	if (!headers) {
		return null;
	}

	if (typeof headers.get === 'function') {
		return headers.get(name);
	}

	return headers[name] ?? headers[name.toLowerCase()] ?? null;
};

const getFilenameFromResponse = (headers, fallback = 'export.xlsx') => {
	const disposition = getHeaderValue(headers, 'Content-Disposition');
	if (disposition) {
		const asciiMatch = disposition.match(/filename="([^"]+)"/i);
		if (asciiMatch?.[1]) {
			return asciiMatch[1];
		}

		const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
		if (utf8Match) {
			try {
				return decodeURIComponent(utf8Match[1]);
			} catch (e) {
				/* ignore */
			}
		}

		const looseMatch = disposition.match(/filename="?([^";]+)"?/i);
		if (looseMatch?.[1]) {
			return looseMatch[1];
		}
	}

	const encodedName = getHeaderValue(headers, 'X-Export-Filename');
	if (encodedName) {
		try {
			return decodeURIComponent(encodedName);
		} catch (e) {
			return encodedName;
		}
	}

	return fallback;
};

const ensureXlsxFilename = (fileName) => {
	const normalized = (fileName || 'export.xlsx').trim();
	return normalized.toLowerCase().endsWith('.xlsx')
		? normalized
		: `${normalized.replace(/\.+$/, '')}.xlsx`;
};

const isXlsxBinary = (buffer) => {
	const bytes = new Uint8Array(buffer);
	return (
		bytes.length >= 4 &&
		bytes[0] === 0x50 &&
		bytes[1] === 0x4b &&
		bytes[2] === 0x03 &&
		bytes[3] === 0x04
	);
};

const buildDownloadUrl = (path) => {
	if (/^https?:\/\//i.test(path)) {
		return path;
	}

	const base = baseApiUrl().replace(/\/$/, '');
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;

	return `${base}${normalizedPath}`;
};

const downloadFile = async (path) => {
	const token = getStoredAuthToken();
	const url = buildDownloadUrl(path);

	let response;
	try {
		response = await fetch(url, {
			headers: {
				...(token ? { Authorization: `Bearer ${token}` } : {}),
				Accept: `${EXCEL_MIME}, application/octet-stream, application/json`,
			},
		});
	} catch (err) {
		errorToast('اتصال به سرور برقرار نشد. بک‌اند را بررسی کنید.');
		throw err;
	}

	const buffer = await response.arrayBuffer();
	const contentType = getHeaderValue(response.headers, 'content-type') || '';

	if (response.status === 401) {
		resetToken();
		throw new Error('unauthorized');
	}

	if (!response.ok) {
		errorToast('دانلود فایل با خطا مواجه شد');
		throw new Error('download failed');
	}

	if (contentType.includes('application/json')) {
		errorToast('سرور خروجی اکسل برنگرداند');
		throw new Error('json response');
	}

	if (!isXlsxBinary(buffer)) {
		const preview = new TextDecoder().decode(buffer.slice(0, 120)).toLowerCase();
		if (preview.includes('<!doctype') || preview.includes('<html')) {
			errorToast('خطای سرور هنگام تولید فایل اکسل');
		} else {
			errorToast('فایل دریافتی معتبر نیست');
		}
		throw new Error('invalid excel file');
	}

	const blob = new Blob([buffer], { type: EXCEL_MIME });
	const fileName = ensureXlsxFilename(getFilenameFromResponse(response.headers));
	const objectUrl = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = fileName;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.URL.revokeObjectURL(objectUrl);
};

let ApiExport = {
	get: (url, variables, fullfill, reject) =>
		api('get', url, variables, fullfill, reject),
	post: (url, variables, fullfill, reject, fileUpload) =>
		api('post', url, variables, fullfill, reject, fileUpload),
	put: (url, variables, fullfill, reject, fileUpload) =>
		api('put', url, variables, fullfill, reject, fileUpload),
	delete: (url, variables, fullfill, reject) =>
		api('delete', url, variables, fullfill, reject),
	batchGet: (urls) => batchGet(urls),
	downloadFile: (path) => downloadFile(path),
};

export default ApiExport;
